import type { Routes } from '@angular/router';

import { GenerationFormStore } from '#modules/keywords/stores/generation-form.store';

export const KEYWORDS_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('#modules/keywords/layouts/keywords-layout/keywords-layout.component').then((m) => m.KeywordsLayoutComponent),
        providers: [GenerationFormStore],
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'list',
            },
            {
                path: 'list',
                loadComponent: () =>
                    import('#modules/keywords/views/keywords-list/keywords-list.component').then((m) => m.KeywordsListComponent),
            },
        ],
    },
];
